import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';

interface ConfirmarEnvioTermoModalProps {
    show: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
    destinatario: string;
    quantidade?: number;
}

const ConfirmarEnvioTermoModal: React.FC<ConfirmarEnvioTermoModalProps> = ({ 
    show, 
    handleClose, 
    handleConfirm, 
    destinatario,
    quantidade
}) => {

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar Envio de Termo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="info">
                    Verifique se é necessário aguardar publicação no DOE para enviar esses termos.
                </Alert>
                <Alert variant="warning">
                    Atente-se para não reenviar termos para candidatos que já os receberam, o que pode confundi-los.
                </Alert>
                <p>
                    Deseja enviar o termo para {quantidade ? (
                        <span>
                            <strong>{quantidade}</strong> candidato(s)
                        </span>
                    ) : (
                        <strong>{destinatario}</strong>
                    )}?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="success" onClick={handleConfirm}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmarEnvioTermoModal;
